import { ASSETS, CONTACT } from "@/constants/assets";
import { Phone } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy-deep py-10">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
      <div className="rounded-xl bg-white p-2">
        <img src={ASSETS.logo} alt={`${CONTACT.name} logo`} className="h-16 w-auto object-contain" />
      </div>
      <p className="text-sm text-white/50 text-center">
        {CONTACT.name} — Carpet &amp; upholstery cleaning across {CONTACT.location}.
      </p>
      <a
        href={CONTACT.phoneHref}
        className="flex items-center gap-2 text-sm font-semibold text-white hover:text-turquoise transition-colors"
      >
        <Phone className="h-4 w-4" /> {CONTACT.phone}
      </a>
    </div>
  </footer>
);
